import { render, staticRenderFns } from "./Lifestyle2Template.vue?vue&type=template&id=521e6c0e"
import script from "./Lifestyle2Template.vue?vue&type=script&lang=js"
export * from "./Lifestyle2Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports